import { SessionUserServiceData } from 'services/AuthService/Login/loginServiceType';
import buildFetchService from 'services/buildFetchService';
import { OneServiceFetcherNoParams, OneServiceNoParams } from 'types/services/services';
import { AdminSession, UserSession } from 'types/session/user';
import { oneApi } from 'utils/api/api-fetcher';
import setUserId from 'utils/logging/setUserId';
import { STANDARD_CACHE_TIME, STANDARD_STALE_TIME } from 'utils/query/standardOptions';

const SERVICE_ID = 'session';

const getUserFetcher: OneServiceFetcherNoParams<UserSession> = async () => {
  const { data } = await oneApi.get<SessionUserServiceData>('session/user');
  setUserId(`${data.userId}`);

  return {
    ...data,
    userStatus: (data.billingDetails.firstName && 3) || (data.details.phoneNumber && 2) || (data.details.emailAddressValidated && 1) || 0,
  };
};

const getUser: OneServiceNoParams<UserSession> = {
  id: 'getUser',
  serviceId: SERVICE_ID,
  fetcher: getUserFetcher,
  options: {
    staleTime: STANDARD_STALE_TIME.long,
    cacheTime: STANDARD_CACHE_TIME.long,
    refetchOnWindowFocus: false,
  },
};

const isAdminFetcher: OneServiceFetcherNoParams<AdminSession> = async ({ queryClient }) => {
  const serviceFetcher = buildFetchService({ queryClient });

  try {
    // skipErrors: we don't want any default behavior. We want to handle the error ourselves.
    const user = await serviceFetcher({ ...getUser, options: { ...getUser.options, meta: { skipErrors: true } } });

    const isAdmin = !!user.admin;

    if (isAdmin) {
      return { isAdmin: true, user };
    }

    return { isAdmin: false };
  } catch (_) {
    return { isAdmin: false };
  }
};

const isAdmin: OneServiceNoParams<AdminSession> = {
  id: 'isAdmin',
  serviceId: SERVICE_ID,
  fetcher: isAdminFetcher,
  options: {
    staleTime: STANDARD_STALE_TIME.long,
    cacheTime: STANDARD_CACHE_TIME.long,
    refetchOnWindowFocus: false,
    meta: { skipErrors: true }, // we don't want any default behavior. We want to handle the error ourselves.
  },
};

const sessionService = {
  getUser,
  isAdmin,
};

export default sessionService;
